<!--卡余资产明细-->
<template>
    <div class="customerList-module">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
            <div class="add-customer">
                <span>新办卡数：</span>
                <span class="add-customer-number">{{balanceTotal}}</span>
                <span>万</span>
                <span class="sheets">张数：</span>
                <span class="add-customer-number">{{totalCardCount}}</span>
                <span>张</span>
            </div>
            <div class="list-box">
                <!-- 下拉刷新 -->
                <div class="customer-list" v-for="(item, index) in newCardList" :key="index"
                    @click="toDetail(item.cardLevel,item.cardName)">
                    <div class="flex-y-center">
                        <div class="customer-info flex-1">
                            {{item.cardName}}
                        </div>
                        <img class="arrow_right" referrerpolicy="no-referrer" alt=""
                            src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/arrow_right.png" />
                    </div>
                    <div class="customer-remark flex-between flex-y-center">
                        <div class="flex-between flex-y-center">
                            <span class="sale-name">资产：</span>
                            <span class="sale-number">{{item.cardPropertyAmount}}万</span>
                        </div>
                        <div class="flex-between flex-y-center">
                            <span class="sale-name">张数：</span>
                            <span class="sale-number">{{item.cardCount}}</span>
                        </div>
                        <div class="flex-between flex-y-center">
                            <span class="sale-name">持有顾客数：</span>
                            <span class="sale-number">{{item.customerCount}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </van-pull-refresh>
    </div>
</template>

<script>
import request from "@/utils/request";
import { Toast } from "vant";

export default {
    name: "cardBalanceAssets",
    components: {
    },
    data() {
        return {
            balanceTotal: 0,   //资产总额
            totalCardCount: 0,    //资产总张数
            newCardList: [],    // 列表
            refreshing: false,   // 刷新

        };
    },
    computed: {
    },
    mounted() {
        this.onLoad()
    },
    methods: {
        onLoad() {
            this.loading = true
            request({
                url: `/debt/storeCardProperty?id=${this.$route.query.id}&storeId=${this.$route.query.storeId}`,
                method: "get",
            })
                .then((res) => {
                    this.newCardList = res.data.cardPropertyList;
                    this.balanceTotal = res.data.totalCardBalanceAmount;
                    this.totalCardCount = res.data.totalCardCount;

                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                }).finally(() => {

                });
        },

        onRefresh() {
            this.newCardList = [];
            this.refreshing = false;
            this.onLoad();
        },
        //查看详情
        toDetail(cardLevel, cardName) {
            this.$router.push({
                name: "cardBalanceDetail", query: {
                    cardId: cardLevel, cardName: cardName, id: this.$route.query.id,
                    storeId: this.$route.query.storeId
                }
            });
        },

    },
};
</script>

<style scoped lang="less">
::-webkit-scrollbar {
    display: none;
}
.mr-30 {
    margin-right: 30px;
}
.add-customer {
    font-weight: 400;
    color: #66757f;
    font-size: 26px;
    line-height: 37px;
    margin: 50px 0 40px 31px;
}
.customer-info {
    height: 42px;
    font-size: 30px;
    font-weight: 700;
    color: #35434c;
    line-height: 42px;
    margin-top: 10px;
}
.sheets {
    margin-left: 30px;
}
.add-customer-number {
    color: #f65252;
    font-weight: 700;
    font-size: 30px;
}

.list-box {
    width: 100%;
    height: calc(100vh - 245px);
    justify-content: space-between;
    margin: 0 auto 0;
    position: relative;
    z-index: 1;
    overflow-y: auto;
    padding: 0 30px 30px 30px;
}

.customer-list {
    width: 690px;
    height: 172px;
    background: #fafafe;
    border-radius: 20px;
    padding: 20px;
    margin-bottom: 20px;
}
.customer-name {
    min-width: 60px;
    height: 42px;
    font-size: 30px;
    color: #35434c;
    line-height: 42px;
    font-weight: 700;
}
.churn-time {
    height: 37px;
    font-size: 26px;
    color: #a0acb5;
    line-height: 37px;
    margin-top: 11px;
}
.nursing-edit-box {
    margin: 37px 0 0 163px;
}
.arrow_right {
    width: 15px;
    height: 26px;
}

.card-image {
    height: 34px;
    width: 90px;
    margin: 24px 0 0 10px;
}
.customerHeadPortrait {
    width: 90px;
    height: 90px;
    border-radius: 45px;
}
.customer-remark {
    padding: 30px 0 30px 0;
}
.sale-name {
    height: 40px;
    font-size: 28px;
    color: #a0acb5;
    line-height: 40px;
}
.sale-number {
    height: 40px;
    font-size: 28px;
    font-weight: 700;
    color: #35434c;
    line-height: 40px;
}
.select-box {
    margin-left: 30px;
    .select-tit {
        font-size: 28px;
        color: #35434c;
    }
    .select-arrow {
        transform: rotate(90deg);
        font-size: 24px;
        margin-left: 10px;
    }
}
</style>

